<template>
    <v-app>
        <v-app-bar
            :extended="!hasLoaded"
            extension-height="10"
            color="#f5f5f5"
            max-height="65"
            app
        >
            <v-app-bar-nav-icon
                v-if="isBookActive"
                @click="toggleSidebar()"
            ></v-app-bar-nav-icon>
            <img
                style="width: 50px; background-color: transparent"
                class="logo"
                src="@/assets/logo-square.png"
            />

            <v-app-bar-title>CFMA eReader</v-app-bar-title>

            <v-chip v-if="!isConnected" class="ml-2" color="warning" label>
                Offline Mode
            </v-chip>

            <v-spacer></v-spacer>

            <template v-if="isBookActive">
                <v-btn
                    elevation="0"
                    v-if="currentBook"
                    @click="applyBookmark()"
                >
                    <v-icon v-if="activeBookmark" dark
                        >mdi-bookmark-check
                    </v-icon>
                    <v-icon v-else dark>mdi-bookmark-outline</v-icon>
                </v-btn>
                <v-btn
                    style="margin-left: 5px"
                    elevation="0"
                    v-if="currentBook"
                    @click="backToList()"
                >
                    <v-icon dark>mdi-backspace</v-icon>
                </v-btn>
            </template>
            <template v-else>
                <v-btn @click="$store.dispatch('getBooks', true)" icon>
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
            </template>
            <template v-slot:extension>
                <v-progress-linear
                    v-if="!hasLoaded"
                    :active="!hasLoaded"
                    :indeterminate="!hasLoaded"
                    color="primary"
                    height="5"
                />
            </template>
        </v-app-bar>
        <sidebar />
        <v-main>
            <v-offline
                online-class="online"
                offline-class="offline"
                @detected-condition="onNetworkChange"
            >
                <router-view />
            </v-offline>
        </v-main>
    </v-app>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import Sidebar from "./components/Sidebar";
import { VOffline } from "v-offline";

export default {
    name: "App",
    components: { Sidebar, VOffline },
    data: () => ({}),
    methods: {
        ...mapMutations(["closeBook"]),
        ...mapMutations(["setBookmarkState", "setSidebar"]),
        ...mapActions(["setBookmarkState"]),
        toggleSidebar() {
            this.setSidebar();
        },
        backToList() {
            this.$router.back();
        },
        applyBookmark() {
            this.setBookmarkState(this.currentPageObj);
        },
        onNetworkChange(status) {
            this.isConnected = status;
        },
    },
    computed: {
        ...mapFields(["isSidebarActive"]),
        ...mapFields({
            isConnected: "isOnline",
        }),
        ...mapState([
            "currentPage",
            "currentPageObj",
            "currentBook",
            "notLoggedIn",
            "activeBookmark",
            "hasLoaded",
        ]),
        isBookActive() {
            return this.$route.name === "viewEBook";
        },
    },
};
</script>
